import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  ExerciseTransactionReversalService,
  Wealthlane_Shared_Hosting_Dtos_GenericApiResponse,
} from '../../services/wealthlane-award-services';

const useDeleteExerciseTransactionReversal = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  onClose: () => void
): UseMutationResult<
  Wealthlane_Shared_Hosting_Dtos_GenericApiResponse | undefined,
  unknown,
  string,
  unknown
> => {
  const queryClient = useQueryClient();

  return useMutation(
    async (transactionId: string) => {
      return await handleRequest(
        ExerciseTransactionReversalService.deleteApiAwardApiAppExerciseTransactionReversalExerciseTransaction(
          transactionId
        )
      );
    },
    {
      onSuccess: async (response: any) => {
        onClose && onClose();
        if (response !== null) {
          toast.success(
            <ToastComponent label='Success' message='Exercise transaction reversed and deleted.' />
          );
          queryClient.invalidateQueries('getOptionExercisedList');
        }
      },
      onError: (err) => {
        onClose && onClose();
        console.log('error', err);
      },
    }
  );
};

export default useDeleteExerciseTransactionReversal;
